import config from "config"

export const fetchReports = async (filters = {}, page = 0) => {
  const {
    extension = "",
    fileName = "",
    servicio = "",
    usuario = "",
    status = "",
    fechaDesde = "",
    fechaHasta = "",
  } = filters || {}
  let url = `${config.api.baseURL}/report-center?page=${page}&size=10&sort=dateTime,desc`

  if (extension) url += `&extension=${encodeURIComponent(extension)}`
  if (fileName) url += `&fileName=${encodeURIComponent(fileName)}`
  if (servicio) url += `&servicio=${encodeURIComponent(servicio)}`
  if (usuario) url += `&usuario=${encodeURIComponent(usuario)}`
  if (status) url += `&status=${encodeURIComponent(status)}`
  if (fechaDesde) url += `&fechaDesde=${encodeURIComponent(fechaDesde)}`
  if (fechaHasta) url += `&fechaHasta=${encodeURIComponent(fechaHasta)}`

  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
  const response = await fetch(url, {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) throw new Error("Error al obtener reportes")
  const data = await response.json()

  // El backend puede devolver el DTO plano ({content, totalPages}) o el
  // formato HAL de Spring Data REST ({_embedded: {<algunColeccion>: [...]},
  // page: {totalPages}}), según el ambiente. Normalizamos para no pasarle
  // `undefined` a la tabla si viene HAL.
  const content = Array.isArray(data?.content)
    ? data.content
    : Object.values(data?._embedded ?? {}).find((v) => Array.isArray(v)) ?? []
  const totalPages = data?.totalPages ?? data?.page?.totalPages ?? 0

  return { content, totalPages }
}

export const deleteReport = async (id) => {
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
  const response = await fetch(`${config.api.baseURL}/report-center/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  })

  if (!response.ok) throw new Error("Error al eliminar el reporte")
  return response
}

export const downloadReport = async (id) => {
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
  const response = await fetch(`${config.api.baseURL}/report-center/download/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  })

  if (!response.ok) throw new Error("Error al descargar el archivo")
  return response
}

export const getReportProgress = async (id) => {
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
  const response = await fetch(`${config.api.baseURL}/report-center/${id}/progress`, {
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) throw new Error("Error al obtener el progreso")
  return response.json()
}

const sendReportAction = async (id, action) => {
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
  const response = await fetch(`${config.api.baseURL}/report-center/${id}/${action}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  })
  if (!response.ok) {
    const err = new Error(`Error al ${action} el reporte`)
    err.status = response.status
    throw err
  }
  return response
}

export const pauseReport = (id) => sendReportAction(id, "pause")
export const resumeReport = (id) => sendReportAction(id, "resume")
export const cancelReport = (id) => sendReportAction(id, "cancel")